/**
 * @param {String} version
 * @return {Array}
 */
export function parseVersion(version) {
	const versionNumbers = version.split('.').map(item => parseInt(item));

	if (versionNumbers.length == 0) {
		return undefined;
	}

	while (versionNumbers.length < 3) {
		versionNumbers.push(0);
	}

	return versionNumbers;
}
